import { useAtom } from '@reatom/npm-react'

import {
  CheckCurrencyActive,
  CheckCurrencyFailed,
  CheckCurrencyPassed,
} from '@root/features/premium'
import { useOptionalAtom } from '@root/shared/lib'

import type { CheckCurrencyReatom } from '@root/features/premium'

type Props = {
  model: CheckCurrencyReatom
}

export const CheckCurrencyDialogContent: React.FC<Props> = ({ model }) => {
  const [state] = useAtom(model.checkCurrencyStateAtom)
  const premium = useOptionalAtom(state.value?.premiumInfo?.premium)
  if (!state.value) {
    return <CheckCurrencyFailed result={state.value} model={model} />
  }

  if (premium) {
    return <CheckCurrencyActive result={state.value} />
  }
  if (state.value.hasPassedSecurityChecks) {
    return <CheckCurrencyPassed result={state.value} />
  }

  return <CheckCurrencyFailed result={state.value} model={model} />
}
